import { Trans } from "@mbarzda/solid-i18next"
import { type Component } from "solid-js"
import Dialog from "./Dialog/Dialog"
import DialogActions from "./Dialog/DialogActions"
import { t } from "i18next"
import { useTracking } from "../../../shared/providers/tracking.provider"

export interface EmailDisclaimerDialogProps {
  readonly confirm: () => void
}

const EmailDisclaimerDialog: Component<EmailDisclaimerDialogProps> = (props) => {
  const { trackDisclaimerConfirmed } = useTracking()

  return (
    <Dialog maxWidth={"434px"}>
      <div class="flex gap-4 mx-auto mb-4">
        <div class="text-black flex gap-2 flex-col">
          <span class="font-semibold">
            <Trans key="IMPORTANT" />
          </span>
          <span
            class="text-sm"
            innerHTML={t(
              "After completing your purchase, you’ll need to create a ProfitTree account <b>using the same email address</b> you used at checkout. This ensures we can link your purchase to your account."
            )}
          ></span>
        </div>
      </div>

      <DialogActions>
        <button
          onClick={() => {
            trackDisclaimerConfirmed()
            props.confirm()
          }}
          class="btn btn--primary h-auto!"
        >
          <Trans key="Continue" />
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default EmailDisclaimerDialog
